const TEMPLATE_TAG_TYPE_CONSTANT = {
    Unknown: 0,

    DataFieldReference: 1,
    DataFieldGroupReference: 2,
    AttachmentReference: 3,
    BuiltInFieldReference: 4,

    SignatorySignHere: 5,
    SignatoryInitialHere: 6,
    SignatoryDateSigned: 7,
    SignatoryTextInput: 8,
    SignatorySensitiveInput: 9,

    Specialized: 10,

    WorkflowStatusReference: 11,
    DeadlineDefinitionReference: 12,

    FormCheckboxField: 13,
    FormChoiceField: 14,
    FormRadioButtonField: 15,
    FormTextBoxField: 16,
    FormSignatureField: 17
};

const REFERENCE_TAG_TYPES = [
    TEMPLATE_TAG_TYPE_CONSTANT.DataFieldReference,
    TEMPLATE_TAG_TYPE_CONSTANT.DataFieldGroupReference,
    TEMPLATE_TAG_TYPE_CONSTANT.AttachmentReference,
    TEMPLATE_TAG_TYPE_CONSTANT.BuiltInFieldReference,
    TEMPLATE_TAG_TYPE_CONSTANT.Specialized,
    TEMPLATE_TAG_TYPE_CONSTANT.WorkflowStatusReference,
    TEMPLATE_TAG_TYPE_CONSTANT.DeadlineDefinitionReference
];

const PDF_FORM_FIELD_TAG_TYPES = [
    TEMPLATE_TAG_TYPE_CONSTANT.FormCheckboxField,
    TEMPLATE_TAG_TYPE_CONSTANT.FormChoiceField,
    TEMPLATE_TAG_TYPE_CONSTANT.FormRadioButtonField,
    TEMPLATE_TAG_TYPE_CONSTANT.FormTextBoxField
];

const SIGNATORY_TAG_TYPES = [
    TEMPLATE_TAG_TYPE_CONSTANT.SignatorySignHere,
    TEMPLATE_TAG_TYPE_CONSTANT.SignatoryInitialHere,
    TEMPLATE_TAG_TYPE_CONSTANT.SignatoryDateSigned,
    TEMPLATE_TAG_TYPE_CONSTANT.SignatoryTextInput,
    TEMPLATE_TAG_TYPE_CONSTANT.SignatorySensitiveInput
];

const SIGNATORY_DATA_TARGET_TYPE = {
    StringField: 0,
    DateField: 1,
    SensitiveGroup: 2
};

const SIGNATORY_DATA_FORMAT_TYPE = {
    UNRESTRICTED: 0,
    SSN: 1,
    EIN: 2,
    PHONE: 3,
    ZIP: 4
};

const VALID_STRING_DATA_TYPES = [
    "String",
    "Integer",
    "Decimal",
    "Date",
    "User",
    "Name",
    "Address",
    "PV System",
    "Contact",
    "Incentive",
    "Table",
    "Energy Storage System",
    "Built-In Field",
    "Attachment",
    "Workflow Status"
];
const VALID_CHOICE_DATA_TYPES = ["Choice"];
const VALID_BOOL_DATA_TYPES = ["Boolean"];
const INVALID_DATA_TYPES = ["Custom List", "Sensitive Data"];

/** Track whether template has been upgraded to use smart template tags */
const TEMPLATE_UPGRADE_STATUS = {
    NotUpgraded: 0,
    Upgraded: 1,
    UpgradeFailed: 2
};

/** Get string representation of upgrade status ID */
function getUpgradeStatusString(templateUpgradeStatus) {
    switch (templateUpgradeStatus) {
        case TEMPLATE_UPGRADE_STATUS.NotUpgraded:
            return "Upgrade pending";
        case TEMPLATE_UPGRADE_STATUS.Upgraded:
            return "Upgraded";
        case TEMPLATE_UPGRADE_STATUS.UpgradeFailed:
            return "Manual intervention required";
        default:
            throw `Missing code to handle unknown upgrade status ${templateUpgradeStatus}`;
    }
}

function getUpgradeStatusClass(templateUpgradeStatus) {
    switch (templateUpgradeStatus) {
        case TEMPLATE_UPGRADE_STATUS.NotUpgraded:
            return "text-bubble-warning";
        case TEMPLATE_UPGRADE_STATUS.Upgraded:
            return "text-bubble-success";
        case TEMPLATE_UPGRADE_STATUS.UpgradeFailed:
            return "text-bubble-danger";
        default:
            throw `Missing code to handle unknown upgrade status ${templateUpgradeStatus}`;
    }
}

function getTagTypeName(tag) {
    switch (tag.TagType) {
        case TEMPLATE_TAG_TYPE_CONSTANT.Unknown:
            return "Unknown";
        case TEMPLATE_TAG_TYPE_CONSTANT.DataFieldReference:
            return "Data Field";
        case TEMPLATE_TAG_TYPE_CONSTANT.DataFieldGroupReference:
            return "Data Field Group";
        case TEMPLATE_TAG_TYPE_CONSTANT.AttachmentReference:
            return "Attachment";
        case TEMPLATE_TAG_TYPE_CONSTANT.BuiltInFieldReference:
            return "Built-In Field";
        case TEMPLATE_TAG_TYPE_CONSTANT.SignatorySignHere:
            return "Signature";
        case TEMPLATE_TAG_TYPE_CONSTANT.SignatoryInitialHere:
            return "Initial";
        case TEMPLATE_TAG_TYPE_CONSTANT.SignatoryDateSigned:
            return "Date Signed";
        case TEMPLATE_TAG_TYPE_CONSTANT.SignatoryTextInput:
            return "Signatory Text Input";
        case TEMPLATE_TAG_TYPE_CONSTANT.SignatorySensitiveInput:
            return "Signatory Sensitive Input";
        case TEMPLATE_TAG_TYPE_CONSTANT.Specialized:
            return "Specialized";
        case TEMPLATE_TAG_TYPE_CONSTANT.WorkflowStatusReference:
            return "Workflow Status";
        case TEMPLATE_TAG_TYPE_CONSTANT.DeadlineDefinitionReference:
            return "Deadline";
        case TEMPLATE_TAG_TYPE_CONSTANT.FormCheckboxField:
            return "Checkbox Field";
        case TEMPLATE_TAG_TYPE_CONSTANT.FormChoiceField:
            return "Choice Field";
        case TEMPLATE_TAG_TYPE_CONSTANT.FormRadioButtonField:
            return "Radio Button Field";
        case TEMPLATE_TAG_TYPE_CONSTANT.FormTextBoxField:
            return "Text Box Field";
        case TEMPLATE_TAG_TYPE_CONSTANT.FormSignatureField:
            return "Signature Field";
        default:
            throw `Missing code to handle tag type ${tag.TagType}`;
    }
}

function canTagBeMapped(tag) {
    return (
        tag.TagType === TEMPLATE_TAG_TYPE_CONSTANT.SignatoryTextInput ||
        tag.TagType === TEMPLATE_TAG_TYPE_CONSTANT.SignatoryDateSigned ||
        tag.TagType === TEMPLATE_TAG_TYPE_CONSTANT.SignatorySensitiveInput
    );
}

function canTagBeFormatted(tag) {
    return (
        tag.TagType === TEMPLATE_TAG_TYPE_CONSTANT.SignatorySensitiveInput ||
        tag.TagType === TEMPLATE_TAG_TYPE_CONSTANT.SignatoryTextInput
    );
}

function isBuiltInReferenceTag(tag) {
    return (
        tag.TagType === TEMPLATE_TAG_TYPE_CONSTANT.BuiltInFieldReference ||
        tag.TagType === TEMPLATE_TAG_TYPE_CONSTANT.Specialized
    );
}

const signatoryTagSuffixByType = {
    [TEMPLATE_TAG_TYPE_CONSTANT.SignatorySignHere]: "Sign",
    [TEMPLATE_TAG_TYPE_CONSTANT.SignatoryInitialHere]: "Initial",
    [TEMPLATE_TAG_TYPE_CONSTANT.SignatoryDateSigned]: "Date",
    [TEMPLATE_TAG_TYPE_CONSTANT.SignatoryTextInput]: "Text",
    [TEMPLATE_TAG_TYPE_CONSTANT.SignatorySensitiveInput]: "Sensitive"
};
function getSignatoryTagSuffixFromType(tagType) {
    if (!SIGNATORY_TAG_TYPES.includes(tagType)) {
        throw `Invalid signatory tag type ${tagType}`;
    }

    return signatoryTagSuffixByType[tagType];
}

export {
    getTagTypeName,
    canTagBeFormatted,
    canTagBeMapped,
    isBuiltInReferenceTag,
    getUpgradeStatusString,
    getUpgradeStatusClass,
    getSignatoryTagSuffixFromType,
    TEMPLATE_TAG_TYPE_CONSTANT,
    REFERENCE_TAG_TYPES,
    PDF_FORM_FIELD_TAG_TYPES,
    SIGNATORY_TAG_TYPES,
    SIGNATORY_DATA_TARGET_TYPE,
    VALID_STRING_DATA_TYPES,
    VALID_CHOICE_DATA_TYPES,
    VALID_BOOL_DATA_TYPES,
    INVALID_DATA_TYPES,
    TEMPLATE_UPGRADE_STATUS,
    SIGNATORY_DATA_FORMAT_TYPE
};
